module.exports = __webpack_public_path__ + "static/media/silver-badge 3.9e347b61.png";